module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<table class="datatable">\n    <thead>\n        <th class="select"></th>\n        <th>Name</th>\n        <th>Groups</th>\n        <th>\n            <abbr title="Contact is gift aid eligble">GA</abbr>\n        </th>\n        <th>\n            <abbr title="Contact has a parent on Joinos">J</abbr>\n        </th>\n    </thead>\n    <tbody></tbody>\n</table>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/contacts/table.html
// module id = 258
// module chunks = 0